/**
 * @file: useInspectionNavHeader.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useAdaptiveContainerWidth } from '@euler/functions/useAdaptiveContainerWidth';
import { useState } from 'react';
import { useSharedValue } from 'react-native-reanimated';

export const useInspectionNavHeader = () => {
  const activeIndex = useSharedValue(0);
  const width = useAdaptiveContainerWidth();
  const [navHeaderHeight, setNavHeaderHeight] = useState(0);
  return { activeIndex, width, navHeaderHeight, setNavHeaderHeight };
};
